module.exports = __webpack_public_path__ + "static/details-13-8f84eb06c4858bca15d9fac4a5c42884.jpg";